import './passengersskeleton.module.scss';
import { SkeletonLoader } from '@msc-b2c/shared-components';

export const PassengersSkeleton = () => {
  return (
    <div className={'passengers-skeleton'}>
      <div className={'passengers-skeleton__single-section'}>
        <div className={'passengers-skeleton__name-container'}>
          <SkeletonLoader
            styleOption="cmp-skeleton__loader checkbox"
            height={'24px'}
            width={'24px'}
          />
          <SkeletonLoader
            styleOption="cmp-skeleton__loader"
            height={'45px'}
          />
        </div>
      </div>

      <hr />

      <div className={'passengers-skeleton__passenger-details'}>
        <div className={'passengers-skeleton__single-section'}>
          <div className={'passengers-skeleton__name-container'}>
            <SkeletonLoader
              styleOption="cmp-skeleton__loader checkbox"
              height={'24px'}
              width={'24px'}
              flexShrink={1}
            />
            <SkeletonLoader
              styleOption="cmp-skeleton__loader"
              height={'45px'}
              flexShrink={1}
            />
          </div>
          <SkeletonLoader
            styleOption="cmp-skeleton__loader language"
            height={'56px'}
            flexShrink={1}
          />
        </div>

        <div className={'passengers-skeleton__single-section'}>
          <div className={'passengers-skeleton__name-container'}>
            <SkeletonLoader
              styleOption="cmp-skeleton__loader checkbox"
              height={'24px'}
              width={'24px'}
              flexShrink={1}
            />
            <SkeletonLoader
              styleOption="cmp-skeleton__loader"
              height={'45px'}
              flexShrink={1}
            />
          </div>
          <SkeletonLoader
            styleOption="cmp-skeleton__loader language"
            height={'56px'}
            flexShrink={1}
          />
        </div>
      </div>
    </div>
  );
};
